// extracted by mini-css-extract-plugin
export default {"searchContainer":"FoundPageSearch_searchContainer__gPJhZ","searchBox":"FoundPageSearch_searchBox__MSr9J","searchIcon":"FoundPageSearch_searchIcon__Dq-kl"};